module.exports = __webpack_public_path__ + "static/media/ticket-wcra.f824eaf8.svg";